import { FIXED_MARKER } from 'pages/special/OrienteeringPage/OConfig';
import { useRef } from 'react';
import {
    GiveMeMap,
    ICoordinates,
    IPinWorldMarker,
    IViewportExtended,
    IWorldMarker
} from 'react-give-me-map';
import { MapRef } from 'react-map-gl';
import styled from 'styled-components/macro';

interface Props {
    viewport: IViewportExtended;
    onViewportChange: (viewport: IViewportExtended) => void;
    corners: {
        topLeft: ICoordinates;
        topRight: ICoordinates;
        bottomRight: ICoordinates;
        bottomLeft: ICoordinates;
    };
    className?: string;
}

export const OBottomMap = (props: Props): JSX.Element => {
    const mapRef3 = useRef<MapRef>(null);
    const viewport3 = props.viewport;

    const finalMarker: IWorldMarker = true
        ? {
              ...FIXED_MARKER,
              elementData: {
                  ...FIXED_MARKER.elementData,
                  renderAsLayer: true,
                  layerData: props.corners
              }
          }
        : null;

    const c = props.corners;
    let points = [];
    if (c)
        points = [
            {
                id: (c.topLeft.lat + c.topLeft.lng).toString(),
                lat: c.topLeft.lat,
                lng: c.topLeft.lng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: '1',
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker,
            {
                id: (c.topRight.lat + c.topRight.lng).toString(),
                lat: c.topRight.lat,
                lng: c.topRight.lng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: '2',
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker,
            {
                id: (c.bottomRight.lat + c.bottomRight.lng).toString(),
                lat: c.bottomRight.lat,
                lng: c.bottomRight.lng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: '3',
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker,
            {
                id: (c.bottomLeft.lat + c.bottomLeft.lng).toString(),
                lat: c.bottomLeft.lat,
                lng: c.bottomLeft.lng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: '4',
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker
        ];

    const markers = finalMarker ? [finalMarker, ...points] : [];

    return (
        <S_OBottomMap className={props.className}>
            <GiveMeMap
                mapRef={mapRef3}
                map={{
                    ...(viewport3.latitude != null ? { latitude: viewport3.latitude } : {}),
                    ...(viewport3.longitude != null ? { longitude: viewport3.longitude } : {}),
                    ...(viewport3.zoom != null ? { zoom: viewport3.zoom } : {}),
                    mapboxAccessToken: process.env.REACT_APP_MAPBOX_TOKEN,
                    onMove: (v) => {
                        props.onViewportChange({
                            latitude: v.viewState.latitude,
                            longitude: v.viewState.longitude,
                            zoom: v.viewState.zoom
                        });
                    },
                    onClick: (e) => {
                        console.log('Click', e.lngLat);
                    },
                    onLoad: (e) => {
                        console.log('Load', e);
                    }
                }}
                callbacks={{}}
                config={{
                    availableStyles: ['mapbox://styles/koudelka/ckwfq7e5k45h814o8521fnwo1']
                }}
                markers={markers}
            />
        </S_OBottomMap>
    );
};

const S_OBottomMap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;
